import { createContext } from 'react';

import { OSPatchEntry } from '@totem/components/osPatchReport/types';
import {
  DeviceFilterOptions,
  DevicesConnectionInput,
} from '@totem/types/devices';

interface Context {
  loading: boolean;
  filteredData: OSPatchEntry[];
  input: DevicesConnectionInput;
  setInput: (input: DevicesConnectionInput) => void;
  filterOptions: DeviceFilterOptions;
}

export default createContext<Context>({
  loading: false,
  filteredData: [],
  input: {},
  setInput: () => {},
  filterOptions: {
    type: [],
    vendor: [],
    operatingSystem: [],
    firmware: [],
    region: [],
    building: [],
    models: [],
  },
});
